import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import { Link, useParams } from 'react-router-dom'
import { ApiService } from '../../../Components/Services/apiServices'
import Skeleton from 'react-loading-skeleton'

const RoomDetail = () => {

    const { room_name } = useParams();
    const [roomdetails, setRoomDetails] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const fetchroomDetail = async () => {
            try {
                setLoading(true);
                const roomDetailData = await ApiService.Commanfetchrequest(`rooms/${room_name}`);
                setRoomDetails(roomDetailData);
                // console.log('room detail:', roomDetailData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        }


        fetchroomDetail();
    }, [room_name]);




    return (
        <>
            <Header />
            {loading ? (
                <>
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-inner">
                                        <Skeleton width={"100%"} height={300} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                <h2><Skeleton width={220} height={40} /></h2>
                                <p className="text-muted"><Skeleton width={100} height={30} /></p>

                                <div className="d-flex mb-3">
                                    <small className="border-end me-3 pe-3"><Skeleton width={70} height={20} /></small>
                                    <small className="border-end me-3 pe-3"><Skeleton width={70} height={20} /></small>
                                    <small><Skeleton width={70} height={20} /></small>
                                </div>
                                <p className="text-body mb-3">
                                    <Skeleton width={"100%"} height={240} />
                                </p>

                                <div className="d-flex gap-2">
                                    <Link to="/rooms" className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto"><Skeleton width={"100%"} height={40} /></Link>
                                    <Link to="/booknow" className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto"><Skeleton width={"100%"} height={40} /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="container py-5">
                    <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    {roomdetails.room_images && roomdetails.room_images.map((image, index) => (
                                        <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={image.id}>
                                            <img src={`https://hoteljpradmin.loopring.in/front/images/rooms/${image.room_images}`} className="d-block w-100" alt={`Room ${index + 1}`} />
                                        </div>
                                    ))}
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#roomCarousel" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#roomCarousel" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                            <h2>{roomdetails.room_name}</h2>
                            <p className="text-muted">₹{roomdetails.room_price}/Day</p>
                            <p className="mb-3">
                                <i className="fa fa-star text-primary" />
                                <i className="fa fa-star text-primary" />
                                <i className="fa fa-star text-primary" />
                                <i className="fa fa-star text-primary" />
                                <i className="fa fa-star text-primary" />
                            </p>
                            <div className="mb-3">
                                {Number(roomdetails.room_quantity) === 0 ? (
                                    <span className="badge bg-danger">Sold Out</span>
                                ) : (
                                    <span className="badge bg-success">Available</span>
                                )}
                            </div>
                            <div className="d-flex mb-3">
                                <small className="border-end me-3 pe-3"><i className="fa fa-bed text-primary me-2" /> 3 Bed</small>
                                <small className="border-end me-3 pe-3"><i className="fa fa-bath text-primary me-2" /> 2 Bath</small>
                                <small><i className="fa fa-wifi text-primary me-2" /> Wifi</small>
                            </div>
                            <p className="text-body mb-3" dangerouslySetInnerHTML={{ __html: roomdetails.description }} />



                            <p className="text-body mb-3">
                                <span style={{ fontSize: "16px", fontWeight: "600" }}>About Space :-</span><br />
                                <span dangerouslySetInnerHTML={{ __html: roomdetails.about_space }}></span>
                            </p>

                            <p className="text-body mb-3">
                                <span style={{ fontSize: "16px", fontWeight: "600" }}>Guest Access :-</span><br />
                                <span dangerouslySetInnerHTML={{ __html: roomdetails.guest_access }}></span>
                            </p>

                            <p className="text-body mb-3">
                                <span style={{ fontSize: "16px", fontWeight: "600" }}>Other Things to Note Down :-</span><br />
                                <span dangerouslySetInnerHTML={{ __html: roomdetails.guest_access }}></span>

                            </p>

                            <div className="d-flex gap-2">
                                <Link to="/" className="btn btn-sm btn-primary rounded py-2 px-4 w-100 w-md-auto">Back to Home</Link>
                                <Link to={`/booking/${roomdetails.room_name}`} className="btn btn-sm btn-dark rounded py-2 px-4 w-100 w-md-auto">Book Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    )
}

export default RoomDetail
